import type { PropsWithChildren } from 'react';

export function HeaderFooterGrid({ children }: PropsWithChildren) {
  return (
    <div className="grid h-full box-border grid-rows-[auto_1fr_auto]">
      {children}
    </div>
  );
}
